(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Note: the hero (.cn-hero__content children) animates via pure CSS
  // (@keyframes cn-hero-in), independent of this script, so above-the-fold
  // content is never gated on JS/GSAP loading successfully.

  function tagRevealTargets() {
    var selectors = [
      '.cn-trust-item',
      '.cn-feature',
      '.shopify-section .image-banner__content',
      '.shopify-section .spotlight-block__content',
      '.shopify-section .customer-testimonial',
      '.product-item'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    nodes.forEach(function (el) {
      if (!el.classList.contains('cn-reveal')) el.classList.add('cn-reveal');
    });
    return nodes;
  }

  function revealAllImmediately(nodes) {
    nodes.forEach(function (el) { el.classList.add('is-visible'); });
  }

  function init() {
    if (reduceMotion || typeof gsap === 'undefined') {
      return; // content stays visible via default CSS; no reduced-motion penalty
    }

    document.documentElement.classList.add('js-cn-motion');
    var targets = tagRevealTargets();

    try {
      if (typeof ScrollTrigger === 'undefined') {
        revealAllImmediately(targets);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      // Batch product grids for a natural wave stagger
      ScrollTrigger.batch('.product-item.cn-reveal', {
        start: 'top 92%',
        onEnter: function (batch) {
          gsap.to(batch, {
            opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power2.out',
            onStart: function () { batch.forEach(function (el) { el.classList.add('is-visible'); }); }
          });
        },
        once: true
      });

      // Feature cards + generic content blocks: single fade/rise reveal
      document.querySelectorAll('.cn-reveal:not(.product-item):not(.cn-trust-item)').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 90%',
          once: true,
          onEnter: function () { el.classList.add('is-visible'); }
        });
      });

      // Trust bar: small stagger
      var trustItems = document.querySelectorAll('.cn-trust-item.cn-reveal');
      if (trustItems.length) {
        ScrollTrigger.create({
          trigger: trustItems[0].closest('.cn-trust-bar') || trustItems[0],
          start: 'top 90%',
          once: true,
          onEnter: function () {
            trustItems.forEach(function (el, i) {
              setTimeout(function () { el.classList.add('is-visible'); }, i * 80);
            });
          }
        });
      }
    } catch (err) {
      // Any GSAP/ScrollTrigger failure must never leave content permanently hidden.
      revealAllImmediately(targets);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
